module.exports = __webpack_public_path__ + "static/media/reservation-title-open@2x.8639e907.png";